import React, { useContext, useRef, useState, useMemo } from 'react'
import ModalWindow from 'components/ModalWindow'
import { Button, Icon, Popup } from 'semantic-ui-react'
import { injectIntl } from 'react-intl'
import { UserContext, NotifyContext } from 'context'

import api from 'actions/api'

import doRequest from 'actions/doRequest'

function ApplicationConfirmModal(props) {
    const { application = null, applicationsIdList = [], action, closeParentModal = null, intl, reloadApp, withoutLabel = false } = props
    const { logout } = useContext(UserContext)

    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)

    const abortRequestRef = useRef(null)

    const { pushNotify } = useContext(NotifyContext)

    const translates = useMemo(() => ({
        confirm: intl.formatMessage({ id: 'btn.confirm' }),
        cancelApplication: intl.formatMessage({ id: 'btn.cancelApplication' }),
        cancelApplications: intl.formatMessage({ id: 'btn.cancelApplications' }),
        confirmMessage: intl.formatMessage({ id: 'msg.applicationConfirming' }),
        cancelMessage: intl.formatMessage({ id: 'msg.applicationCanceling' }),
        applicationsConfirmMessage: intl.formatMessage({ id: 'msg.applicationsConfirming' }),
        applicationsCancelMessage: intl.formatMessage({ id: 'msg.applicationsCanceling' }),
        yes: intl.formatMessage({ id: 'btn.yes' }),
        no: intl.formatMessage({ id: 'btn.no' }),
        confirmActionTitle: intl.formatMessage({ id: 'title.confirmAction' })
    }), [intl.locale]) // eslint-disable-line react-hooks/exhaustive-deps

    const getButtons = () => [
        { title: translates.yes, onClick: editApplication, disabled: loading, loading: loading },
        { title: translates.no, onClick: () => setOpen(false), disabled: false, loading: false },
    ]

    const openModal = () => {
        setOpen(true)
    }

    const closeModal = () => {
        setOpen(false)
        applicationsIdList.length === 0 && closeParentModal()
    }

    const editApplication = () => {
        setLoading(true)

        const req = applicationsIdList.length > 0 ?
            doRequest(api.applications.updateApplicationsList({ applicationsIdList, statusId: action === 'confirm' ? 3 : 4 }), pushNotify, logout)
            :
            doRequest(api.applications.editApplication({ id: application.id, statusId: action === 'confirm' ? 3 : 4 }), pushNotify, logout)
        abortRequestRef.current = req.abort

        req.ready.then(data => {
            if (data) {
                pushNotify('success', 'title.success', 'msg.sendRequstSuccess', 2000)
            }
        }).catch(console.error)
            .finally(() => {
                setLoading(false)
                closeModal()
                reloadApp()
            })

    }

    return (
        <ModalWindow
            closeIcon
            size="tiny"
            iconType="info"
            title={translates.confirmActionTitle}
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => openModal()}
            trigger={
                withoutLabel ?
                    <Button className="actionButton" icon><Popup inverted content={action === 'confirm' ? translates.confirm : applicationsIdList.length > 1 ? translates.cancelApplications : translates.cancelApplication} trigger={<Icon name={action === 'confirm' ? "check circle" : "undo"} />} /></Button>
                    :
                    <Button className="actionButton" icon><Icon name={action === 'confirm' ? "check circle" : "undo"} />
                        <span>{action === 'confirm' ? translates.confirm : applicationsIdList.length > 1 ? translates.cancelApplications : translates.cancelApplication}</span>
                    </Button>
            }
            actions={getButtons()}
        >
            <div className="applicationConfirmCancel">
                {applicationsIdList.length > 1 ?
                    <h3>{action === 'confirm' ? translates.applicationsConfirmMessage : translates.applicationsCancelMessage}</h3>
                    :
                    <h3>{action === 'confirm' ? translates.confirmMessage : translates.cancelMessage}</h3>
                }
            </div>
        </ModalWindow>
    )
}

export default injectIntl(ApplicationConfirmModal)